<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink="../../">
        Budżet obywatelski
      </a>
    </li>
    <li>
      @if (loading()) {
        Ładowanie...
      } @else {
        <a routerLink="../">{{ budget()?.name }}</a>
      }
    </li>
    <li>
      Zgłoszenie projektu
    </li>
  </app-breadcrumbs>
  <section>
    @if (loading()) {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    } @else {
      <h2>
        Zgłoszenie projektu
      </h2>
      <form novalidate autocomplete="off" [formGroup]="form" (ngSubmit)="submit()">
        <div class="row">
          <div class="col-md-5">
            <div class='form-group' *ngIf='"projectName" as controlName'>
              <label [for]='controlName'>
                Nazwa projektu *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę projektu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-md-5">
            <div class='form-group' *ngIf='"submitter" as controlName'>
              <label [for]='controlName'>
                Zgłaszający *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu zgłaszającego'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-md-4">
            <div class='form-group' *ngIf='"budget" as controlName'>
              <label [for]='controlName'>
                Szacowany koszt *
              </label>
              <input
                mask='separator.2'
                decimalMarker=','
                [dropSpecialCharacters]='false'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu szacowany koszt'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-12">
            <div class='form-group' *ngIf='"description" as controlName'>
              <label [for]='controlName'>
                Opis *
              </label>
              <textarea
                rows="4"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Opisz projekt'>
            </textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-12">
            <div class='form-group' *ngIf='"justification" as controlName'>
              <label [for]='controlName'>
                Uzasadnienie *
              </label>
              <textarea
                rows="4"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu uzasadnienie'>
            </textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <app-file-uploader (pending)="form.uploading = $event" formControlName="attachments" [multiple]="true">
            </app-file-uploader>
          </div>
        </div>
        <div class='application-actions'>
          <button
            type='button'
            class='btn btn-secondary'
            routerLink="../">
            <span>
              Anuluj
            </span>
          </button>
          <button
            [disabled]="(!(budget()?.stage === 'project_submission') && (budget()?.status === 'active')) || form.uploading || pending()"
            type='submit'
            class='btn btn-primary'>
            <span>Wyślij</span>
          </button>
        </div>
      </form>
    }
  </section>
</app-content>
